import Image from "next/image";
import { cn } from "@punchup/utils/cn";

export interface CarouselItemImageBackdropProps {
  imageUrl: string | null;
  alt: string;
  objectFit: "contain" | "cover";
  placeholderContent?: React.ReactNode;
  showGradient?: boolean;
}

export default function CarouselItemImageBackdrop({
  imageUrl,
  alt,
  objectFit,
  placeholderContent,
  showGradient = true,
}: CarouselItemImageBackdropProps) {
  return (
    <>
      {/* Backdrop - Large image with blur effect */}
      <div className="relative w-full h-[300px] md:h-[400px] flex-shrink-0 overflow-hidden z-10">
        {/* only display the blurred background image if we're containing the image */}
        {objectFit === "contain" && (
          <>
            {/* Blurred background image */}
            <div className="absolute inset-0">
              {imageUrl ? (
                <Image
                  src={imageUrl}
                  alt=""
                  fill
                  sizes="(max-width: 768px) 100vw, 800px"
                  className="object-cover blur-sm scale-110 select-none"
                />
              ) : (
                (placeholderContent ?? null)
              )}
            </div>
          </>
        )}

        {/* Main image - contained */}
        <div className="relative z-10 w-full h-full flex items-center justify-center">
          {imageUrl ? (
            <Image
              src={imageUrl}
              alt={alt}
              fill
              sizes="(max-width: 768px) 100vw, 500px"
              className={cn(
                "select-none",
                objectFit === "contain" ? "object-contain" : "object-cover"
              )}
            />
          ) : null}
        </div>
      </div>

      {/* Gradient overlay */}
      {showGradient && (
        <div className="absolute z-20 bottom-0 left-0 right-0 w-full h-[180px] bg-gradient-to-b from-transparent via-black/40 via-50% to-black" />
      )}
    </>
  );
}
